import { t } from "@/i18n-js/instance";
import type { GetRecommendationsResponse } from "@/react/api/recommendations/recommendationsApi";
import { LoaderRow } from "@/react/components/shared/LoaderRow";
import { CommunityMemberWithConnection } from "@/react/components/shared/MembersList/CommunityMembers/ListView/CommunityMemberV2/CommunityMemberWithConnection";
import { Typography } from "@/react/components/shared/uikit/Typography";
import { EmptyRecommendations } from "./EmptyRecommendations";

const i18nBase = "members_directory.recommendations";

export const Recommendations = ({
  recommendations,
  isLoading,
  shouldHideHeader,
  isError,
}: {
  recommendations?: GetRecommendationsResponse;
  isLoading?: boolean;
  shouldHideHeader?: boolean;
  isError?: boolean;
}) => (
  <div className="mx-2 mt-6 flex flex-col gap-y-6">
    {shouldHideHeader ? null : (
      <div className="flex flex-col">
        <Typography.LabelLg weight="semibold">
          {t(`${i18nBase}.title`)}
        </Typography.LabelLg>
        <Typography.BodySm color="text-secondary" weight="medium">
          {t(`${i18nBase}.subtitle`)}
        </Typography.BodySm>
      </div>
    )}

    {isLoading ? (
      <LoaderRow />
    ) : (
      <ul
        className="flex list-none flex-col gap-y-4"
        data-testid="directory_members_list"
      >
        {recommendations?.length === 0 || isError ? (
          <EmptyRecommendations />
        ) : (
          recommendations?.map(communityMember => (
            <CommunityMemberWithConnection
              communityMember={communityMember.target_community_member}
              key={communityMember.target_community_member.id}
              shouldShowHiddenMemberTooltip={false}
            />
          ))
        )}
      </ul>
    )}
  </div>
);
